import { LocaleId } from '../../models/locale.model';

export const TEMPLATE_BLUEPRINTS = {
  2: 'emea-vas-template',
  3: { property: 'china-beijing-template', availability: 'china-availability-beijing' },
  4: { property: 'china-shanghai-template', availability: 'china-availability-shanghai' },
  5: 'india-comparison-availability-template',
  6: 'india-office-template',
  7: 'india-retail-template',
  8: 'us-industrial',
  9: 'us-office',
  10: 'us-retail',
  11: 'uk-industrial-template',
  12: 'tim-table-view',
  13: 'us-availability-industrial',
  14: 'us-availability-office',
  15: 'us-availability-retail',
  16: 'pacific-availability-office',
  17: 'pacific-availability-retail',
  18: 'pacific-availability-industrial',
  19: 'pacific-summary-office',
  20: 'pacific-summary-retail',
  21: 'pacific-summary-industrial',
  22: 'pacific-availability-nz-industrial',
  23: 'china-summary',
  24: 'uk-international-template',
  25: 'lease-table-view',
  26: 'availability-table-view',
  27: 'property-table-view',
  28: 'sale-table-view',
  29: 'china-comparison-availability-template',
  35: {
    [LocaleId.PolandEnglish]: 'poland-office-property-shortlist-template',
    [LocaleId.PolandPolish]: 'poland-office-property-shortlist-template',
    [LocaleId.ItalyEnglish]: 'italy-office-property-shortlist-template',
    [LocaleId.ItalyItalian]: 'italy-office-property-shortlist-template',
    [LocaleId.SwedenEnglish]: 'sweden-office-property-shortlist-template',
    [LocaleId.SwedenSwedish]: 'sweden-office-property-shortlist-template',
    [LocaleId.NorwayEnglish]: 'norway-office-property-shortlist-template',
    [LocaleId.NorwayNorwegian]: 'norway-office-property-shortlist-template',
    [LocaleId.FinlandEnglish]: 'finland-office-property-shortlist-template',
    [LocaleId.FinlandFinnish]: 'finland-office-property-shortlist-template',
    // Both Netherlands locales reference the Norway template because the same id's from that country were used
    [LocaleId.NlEnglish]: 'norway-office-property-shortlist-template',
    [LocaleId.NlDutch]: 'norway-office-property-shortlist-template',
  },
  34: {
    [LocaleId.PolandEnglish]: 'poland-office-property-longlist-template',
    [LocaleId.PolandPolish]: 'poland-office-property-longlist-template',
    [LocaleId.ItalyEnglish]: 'italy-office-property-longlist-template',
    [LocaleId.ItalyItalian]: 'italy-office-property-longlist-template',
    [LocaleId.SwedenEnglish]: 'sweden-office-property-longlist-template',
    [LocaleId.SwedenSwedish]: 'sweden-office-property-longlist-template',
    [LocaleId.NorwayEnglish]: 'norway-office-property-longlist-template',
    [LocaleId.NorwayNorwegian]: 'norway-office-property-longlist-template',
    [LocaleId.FinlandEnglish]: 'finland-office-property-longlist-template',
    [LocaleId.FinlandFinnish]: 'finland-office-property-longlist-template',
    // Both Netherlands locales reference the Norway template because the same id's from that country were used
    [LocaleId.NlEnglish]: 'norway-office-property-longlist-template',
    [LocaleId.NlDutch]: 'norway-office-property-longlist-template',
  },
  36: {
    [LocaleId.PolandEnglish]: 'poland-office-availabilities-template',
    [LocaleId.PolandPolish]: 'poland-office-availabilities-template',
    [LocaleId.ItalyEnglish]: 'italy-office-availabilities-template',
    [LocaleId.ItalyItalian]: 'italy-office-availabilities-template',
    [LocaleId.SwedenEnglish]: 'sweden-office-availabilities-template',
    [LocaleId.SwedenSwedish]: 'sweden-office-availabilities-template',
    [LocaleId.NorwayEnglish]: 'norway-office-availabilities-template',
    [LocaleId.NorwayNorwegian]: 'norway-office-availabilities-template',
    [LocaleId.FinlandEnglish]: 'finland-office-availabilities-template',
    [LocaleId.FinlandFinnish]: 'finland-office-availabilities-template',
  },
  37: 'uk-long-income-template',
  38: 'us-lease-industrial-condensed',
  39: 'us-lease-office-condensed',
  40: { property: 'uk-research-availability-template', availability: 'uk-research-availability-availability-template' },
  41: 'industrial/emea-industrial-longlist-template',
  42: 'uk-research-development-pipeline',
  43: 'india-office-grouped-template',
  44: 'india-retail-grouped-template',
};

export const PACIFIC_TEMPLATE_IDS = [16, 17, 18, 19, 20, 21, 22];

export const PACIFIC_AVAILABILITIES_IDS = [16, 17, 18, 22];

export const INDIA_CUSTOM_GROUP_TEMPLATE_IDS = [6, 7];

export const TEMPLATE_LAYOUT = {
  PORTRAIT: [19],
  LANDSCAPE: [20, 21],
};

export const CHINA_SUMMARY_MAPSIZE_ON_RECORDCOUNT = 20;

export const PACIFIC_TEMPLATES_IMAGE_ORDER = {
  PROPERTY_ORDER: [16, 43, 44],
  AVAILABILITY_ORDER: [17, 18, 22],
};
